var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnyxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 15,
    viewBox: "0 0 67 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2199 14.7752H31.4237L21.6732 3.54944V14.7752H19.7061V0.192429H21.3739L31.2526 11.4823V0.192429H33.2199V14.7752Z",
    fill: "#FFFFF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0343 0.192429H49.5573L44.1477 7.07754V14.7752H42.0523V7.05624L36.6425 0.192429H39.1655L43.0786 5.21735L47.0343 0.192429Z",
    fill: "#FFFFF2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1764_20538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H66.256V14.8879H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1764_20538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0337 7.22723L66.256 14.7752H63.7329L58.7722 8.74534L53.7474 14.7752H51.2029L57.4893 7.22723L51.6519 0.192429H54.1965L58.7722 5.75194L63.3267 0.192429H65.8498L60.0337 7.22723Z",
    fill: "#FFFFF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81934 0C3.0939 0 -0.00646973 3.44256 -0.00646973 7.48384C-0.00646973 10.6589 1.93722 13.5567 5.16953 14.5775C5.61371 14.7176 6.08179 14.8228 6.57301 14.8879C6.37574 14.3071 6.02177 14.0003 5.65102 13.679C5.33587 13.4058 5.01196 13.1239 4.78917 12.6867C4.75423 12.6183 4.72146 12.5467 4.69194 12.4701C4.64608 12.3506 4.61158 12.2321 4.58303 12.1138C3.09065 11.1371 2.15309 9.4682 2.15309 7.48384C2.15309 4.27651 4.56919 1.92444 7.81934 1.92444C11.0908 1.92444 13.5071 4.27651 13.5071 7.48384C13.5071 8.85682 13.0575 10.0782 12.2849 11.0245C12.3905 11.8325 12.3391 12.6544 11.9569 13.4026C11.8006 13.7085 11.5937 13.9892 11.338 14.2449C14.0988 13.011 15.6668 10.3504 15.6668 7.48384C15.6668 3.42114 12.6304 0 7.81934 0Z",
    fill: "#FFFFF2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66052 11.0339C8.4467 10.549 8.22564 10.0475 8.09467 9.45676C7.9531 8.81899 7.90962 8.24276 7.94185 7.72093C7.13353 8.3481 6.3026 9.24035 6.80453 10.9432L6.80875 10.959C6.94751 11.5349 7.21616 11.9621 7.47604 12.3751C7.61459 12.5953 7.75096 12.8128 7.86171 13.0423C8.11208 13.5615 8.22953 14.1435 7.93396 14.964C7.92974 14.9759 7.92476 14.9881 7.92033 15C7.93255 14.9877 7.94347 14.9759 7.95548 14.9636C8.76131 14.1433 9.08425 13.496 9.1406 12.9058C9.20192 12.2646 8.94993 11.6903 8.66052 11.0339Z",
    fill: "#FFFFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10088 13.002C7.04626 12.9107 6.98775 12.8175 6.92686 12.7206C6.90848 12.6914 6.88955 12.661 6.87084 12.6312C6.61225 12.2184 6.3329 11.7487 6.17986 11.1189C6.05387 10.6891 6.00055 10.301 6.00141 9.94818C5.2118 10.6282 4.9743 11.3965 5.29756 12.2372C5.34883 12.3704 5.41437 12.4854 5.48921 12.5912C5.64722 12.8147 5.85065 12.9933 6.07604 13.1886C6.52584 13.5785 7.02885 14.0169 7.25737 14.9201C7.30734 14.8036 7.34703 14.6937 7.37764 14.5896C7.57133 13.9274 7.39353 13.4911 7.10088 13.002Z",
    fill: "#FFFFF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9552 8.65793C10.7853 8.18629 10.6388 7.77888 10.5586 7.42642C10.3017 6.29591 10.4666 5.25247 10.6762 4.52451C10.1886 4.81835 9.78569 5.15395 9.46795 5.53085C9.19508 5.85466 8.98494 6.20874 8.83797 6.59279C8.68125 7.00192 8.59582 7.4448 8.58273 7.92121C8.57072 8.35835 8.61885 8.8234 8.72819 9.31625C8.77048 9.50681 8.82488 9.68991 8.8862 9.86771C8.99489 10.1825 9.12586 10.4806 9.25435 10.7721C9.41495 11.1364 9.57296 11.496 9.67798 11.8677C9.75638 12.1448 9.80451 12.4289 9.80235 12.7267C9.79997 13.0423 9.73984 13.3734 9.59784 13.7285C9.45313 14.0903 9.22244 14.4771 8.8795 14.8976C9.02517 14.8513 9.16447 14.802 9.2988 14.7504C9.85026 14.5384 10.3076 14.2809 10.6676 13.9792C10.9762 13.7205 11.2144 13.4299 11.3791 13.1074C11.6113 12.6528 11.6952 12.1573 11.6861 11.6472C11.6682 10.6389 11.2852 9.57408 10.9552 8.65793Z",
    fill: "#FFFFF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84753 14.9075C8.85652 14.9065 8.8655 14.9053 8.87449 14.9044C8.87635 14.9021 8.87799 14.8999 8.87985 14.8976C8.86923 14.9009 8.85816 14.9042 8.84753 14.9075Z",
    fill: "#FFFFFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnyxLogo);
export default __webpack_public_path__ + "static/media/onyx-logo.5139eb33bd2c5913e9b009c47364fee1.svg";
export { ForwardRef as ReactComponent };